import { render } from "./icon.vue?vue&type=template&id=0d0283ec&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import "./icon.vue?vue&type=style&index=0&id=0d0283ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0283ec"]])

export default __exports__